import React from 'react';

interface GradientTextProps {
  children: React.ReactNode;
  className?: string;
}

const GradientText = ({ children, className }: GradientTextProps) => (
    <span className={`bg-gradient-to-r from-blue-400 to-teal-400 text-transparent bg-clip-text ${className || ''}`}>
        {children}
    </span>
);

export default GradientText;
